/*
 * @Description: 调度维护
 * @Author: fxg
 * @Date: 2020-06-29 11:18:28
 * @LastEditors: fxg
 * @LastEditTime: 2020-06-29 13:34:36
*/
import request from '@/utils/request'
export const Download = "/base/system/schedule/export";
export function batchUpdateOrDelete(data) {
  return request({
    url: '/schedule/system/schedule/batch_update_or_delete',
    method: 'post',
    data
  })
}
export function queryPage(data) {
  return request({
    url: '/schedule/system/schedule/query_page',
    method: 'post',
    data
  })
}
export function saveOrUpdate(data) {
  return request({
    url: '/schedule/system/schedule/save_or_update',
    method: 'post',
    data
  })
}
/**查看日志*/
export function get_schedule_logs(data) {
  return request({
    url: '/schedule/system/schedule/get_schedule_logs',
    method: 'post',
    data
  })
}
